import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineSwitchOn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M3.275 8V2.225c0-.58.47-1.05 1.05-1.05H10.1c.58 0 1.05.47 1.05 1.05V8l2.076 5.398a1.05 1.05 0 0 1-.98 1.427H7.342a2.1 2.1 0 0 1-1.96-1.346z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M3.275 8v6.825H8M7.213 3.275V5.9"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.3}
      d="M7.213 11.412a1.312 1.312 0 1 0 2.625 0 1.312 1.312 0 0 0-2.625 0Z"
    />
  </svg>
);
export default SvgStreamlineSwitchOn;
